<app-dialog-header [title]="'Welches Datenbankfeld wollen Sie verlinken?'"
                   (close)="dialogRef.close()"></app-dialog-header>

<mat-form-field appearance="outline">
  <mat-label>Datenbankfelder</mat-label>

  <mat-select [formControl]="selectionValue">
    @for (dataField of data.dataFields; track $index) {
      <mat-option [value]="dataField.internalname">{{ dataField.displayname }}</mat-option>
    }
  </mat-select>
</mat-form-field>

<mat-dialog-actions style="margin-top: 20px">
  <div style="display: flex;">
    <app-confirm-icon-button
      (customClick)="onConfirm()"
    ></app-confirm-icon-button>
    <app-cancel-icon-button
      style="margin-left: 1rem;"
      (click)="onCancel()"
    ></app-cancel-icon-button>
  </div>
</mat-dialog-actions>
